import { ActiveJob } from '#models';

const activeJobsByWell: Record<number, ActiveJob[]> = {
  1: [
    {
      id: 1,
      caseNumber: 'WI-93017',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Wellhead Inspection',
      jobReason: '',
      startDate: '2024-12-22T22:00:00Z',
      endDate: '2024-12-22T22:02:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'Pre Scheduling',
      caseType: 'Wellhead Inspection',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
    {
      id: 2,
      caseNumber: 'PA-123002',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Plug & Abandonment',
      jobReason: '',
      startDate: '2026-04-20T11:54:00Z',
      endDate: '2026-04-20T17:01:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'Land Review',
      caseType: 'Plug & Abandonment',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
    {
      id: 3,
      caseNumber: 'PR-97916',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Pull Request',
      jobReason: 'Rod Pump Upsize',
      startDate: '2024-01-18T03:36:00Z',
      endDate: '2024-01-18T03:36:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'Troubleshooting',
      caseType: 'High Volume',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
    {
      id: 4,
      caseNumber: 'PR-189907',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Pull Request',
      jobReason: '',
      startDate: '2026-04-01T10:07:00Z',
      endDate: '2026-04-01T10:08:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'Troubleshooting',
      caseType: 'Pull Request',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
  ],
  7: [
    {
      id: 1,
      caseNumber: 'PR-98001',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Pull Request',
      jobReason: '',
      startDate: '2026-04-16T14:35:00Z',
      endDate: '2026-04-16T15:00:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'ALS Review',
      caseType: 'Pull Request',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
    {
      id: 2,
      caseNumber: 'PA-98045',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Plug & Abandonment',
      jobReason: '',
      startDate: '2026-04-16T14:37:00Z',
      endDate: '2026-04-16T14:45:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'PE Workbook',
      caseType: 'Plug & Abandonment',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
  ],
  8: [
    {
      id: 1,
      caseNumber: 'PR-88012',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Pull Request',
      jobReason: '',
      startDate: '2026-04-20T11:08:00Z',
      endDate: '2026-04-20T11:30:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'WLM Review',
      caseType: 'Pull Request',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
  ],
  10: [
    {
      id: 1,
      caseNumber: 'RL-55210',
      caseNumberLink: '',
      localReferenceNumber: '',
      jobType: 'Rigless',
      jobReason: '',
      startDate: '2025-12-02T12:00:00Z',
      endDate: '2025-12-02T12:05:00Z',
      jobDurationDays: 1,
      currentCentaurStep: 'Job Execution',
      caseType: 'Rigless',
      nrCaseId: null,
      cpCaseId: null,
      wbCaseId: null,
      rlSentToJobPlan: null,
      rlWellviewJobEntered: null,
    },
  ],
};

export default activeJobsByWell;
